import Vue from "vue";
import Vuex from "vuex";
var WindowType = require("@/static/json/windowtype.json"); //本地json文件数据
var classColor = require("@/static/json/classColor.json");
var Lookup = require('@/static/json/lookup.json');
var Home = require("@/static/json/home.json");
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    flage: false,
    calligarr: '',
    // 默认窗型
    classUrl: "",
    // 默认背景图
    note: {
      width: "100%",
      height: "100%",
      backgroundImage:
        "url(" + require("../../static/image/switchbgO.jpg") + ")",
      backgroundRepeat: "repeat",
      backgroundSize: "100% 100%",
    },
    // 获取用户点击的颜色名称
    Color: "",
    // 获取用户点击的的窗型
    className: "",
    urlName: "",
    resName: "",
    // 用户选中切换
    number: 10000,
  },
  mutations: {
    // 根据用户选择改变背景 推按 颜色
    calligInfo(state, i) {
      // 窗户类型
      if (i.type == "window") {
        WindowType.windowType.forEach((item) => {
          if (i.id == item.id) {
            state.classUrl = item.url;
          }
        });
        return;
        // 窗户颜色
      }
      if (i.type == "color") {
        // 获取到当前用户点击的颜色
        classColor.data.forEach((item) => {
          if (i.id == item.id) {
            state.Color = item.colorName;
            let name = state.classUrl.slice(5);
            let title = name.split(".");
            state.urlName = title[0] + "." + title[2];
          }
        });
        // 在窗型列表获取当前选中的窗型名称
        WindowType.windowType.forEach((res) => {
          let name = res.url.slice(5);
          let title = name.split(".");
          state.resName = title[0] + "." + title[2];
          if (state.resName == state.urlName) {
            state.className = res.title;
            console.log(state.className, "当前窗型名称");
          }
        });
        Lookup.data.forEach((res) => {
          if (state.className == res.title) {
            res.classType.forEach((res) => {
              if (state.Color == res.colorName) {
                console.log(res);
                state.classUrl = require("../../static/image/" + res.url);
              }
            });
          }
        });
        return;
      }
      // 背景图
      if (i.type == "background") {
        if (i.id == 1) {
          state.note = {
            width: "100%",
            height: "100%",
            backgroundImage:
              "url(" + require("../../static/image/switchbgO.jpg") + ")",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
          };
        } else if (i.id == 2) {
          state.note = {
            width: "100%",
            height: "100%",
            backgroundImage:
              "url(" + require("../../static/image/switchbgT.jpg") + ")",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
          };
        }
      }
    },
    // 用户点击分类切换
    classType(state, index) {
      // state.number = 0;
      state.flage = true;
      // 窗型分类
      if (index == 0) {
        state.calligarr = WindowType.windowType;
      } else if (index == 1) {
        state.calligarr = classColor.data;
      } else if (index == 2) {
        state.calligarr = Home.data;
      }
    },
  },
  actions: {
    classTab(state, index) {
      state.commit("calligInfo", index);
    }
  },
});
export default store;
